module.exports = __webpack_public_path__ + "components/country-flag/static/nz-17d2eb5145282d8618d4a06c831b8d0a.svg";